// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__1seES","logo_img":"header_logo_img__4zyx7","logo_h1":"header_logo_h1__uWqXv","logo_h2":"header_logo_h2__YyUi4"};